import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Tabs, Tab } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import GirasTableComponent from "../../components/tables/GirasTableComponent";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { PaginationComponent } from "../../components";
import SolicitudesCupoAdminComponent from "../../components/SolicitudesCupoAdminComponent";
import PageLayout from "../../layouts/PageLayout";
import products from "../../assets/data/giras.json";
import {getEstablecimientos, getRegiones, getComunas, getProgramas, getTramos, getReporteGiras, getReportePagos, getReporteTallas} from "../../api/mantenedores.ts";
import {creaGira, getGiras, cloneGira, obtenerTodosReembolsos} from "../../api/giras.ts";
import Swal from 'sweetalert2';
import { AnchorComponent, ButtonComponent } from "../../components/elements";
import { useAuthStore } from "../../store/auth.store.ts";

export default function GirasListPage() {

    const { t, n } = useContext(TranslatorContext);
    const { usuario } = useAuthStore((state) => state);

    const [selectEstablecimiento, setSelectEstablecimiento] = useState([]);
    const [selectRegion, setSelectRegion] = useState([]);
    const [selectComuna, setSelectComuna] = useState([]);
    const [selectPrograma, setSelectPrograma] = useState([]);
    const [selectTramo, setSelectTramo] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [anioFiltro, setAnioFiltro] = useState(new Date().getFullYear());
    const [busqueda, setBusqueda] = useState('');
    const [reporteGiras, setReporteGiras] = useState([]);
    
    // Estados para el modal de reporte de pagos
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportData, setReportData] = useState({
        fechaInicio: new Date().toLocaleDateString('en-CA'), // Formato YYYY-MM-DD en zona horaria local
        fechaFin: new Date().toLocaleDateString('en-CA')
    });

    // Estados para el modal de reporte de tallas
    const [showReportTallasModal, setShowReportTallasModal] = useState(false);
    const [reportTallasData, setReportTallasData] = useState({
        anio: new Date().getFullYear()
    });

    const anioActual =new Date().getFullYear();
    const anios = [];
    for (let year = 2025; year <= 2028; year++) {
        anios.push(year);
    }

       
    const [alertModal, setAlertModal] = useState(false);

    const [giras, setGiras] = useState([]);
    const [girasFiltradas, setGirasFiltradas] = useState([]);
    const [giraSeleccionada, setGiraSeleccionada] = useState(null);
    const [reembolsos, setReembolsos] = useState([]);
    const [tabActive, setTabActive] = useState('giras');

    // Función para filtrar giras por año y búsqueda
    const filtrarGiras = (girasData, anio, terminoBusqueda) => {
        return girasData.filter((gira) => {
            const cumpleAno = gira.gir_anio === Number(anio);
            
            if (!terminoBusqueda.trim()) {
                return cumpleAno;
            }

            const termino = terminoBusqueda.toLowerCase();
            return cumpleAno && (
                gira.gir_id?.toString().toLowerCase().includes(termino) ||
                gira.est_nombre?.toLowerCase().includes(termino) ||
                gira.gir_curso?.toLowerCase().includes(termino) ||
                gira.programa?.toLowerCase().includes(termino) ||
                gira.tramo?.toLowerCase().includes(termino) ||
                gira.reg_nombre?.toLowerCase().includes(termino) ||
                gira.com_nombre?.toLowerCase().includes(termino)
            );
        });
    };
        useEffect(() => {


            const fectchProgramas = async () => {
                const res = await getProgramas();
                console.log(res);
                setSelectPrograma(res.data);
            }

            const fectchTramos = async () => {
                const res = await getTramos();
                console.log(res);
                setSelectTramo(res.data);
            }

           

            const fecthregiones = async () => {
                const res = await getRegiones();
                console.log(res);
                setSelectRegion(res.data);
            }   
    
            const fecthComunas = async () => {
                const res = await getComunas();
                console.log(res);
                setSelectComuna(res.data);
            }

            const fetchTabla = async () => {
                const res = await getGiras();
                
                setGiras(res);
                  // Filtrar giras por el año actual al cargar
                const girasFiltradasInicial = filtrarGiras(res, anioActual, '');
                setGirasFiltradas(girasFiltradasInicial);
               
            }

            const fetchReporteGiras = async () => {
                const res = await getReporteGiras();
              
                setReporteGiras(res.data);
            }

            const fetchReembolsos = async () => {
                const res = await obtenerTodosReembolsos();
                if (!res.error) {
                    setReembolsos(res.reembolsos || []);
                }
            }

            fectchProgramas();
            fectchTramos();
           // fectchEstablecimientos();
            fecthregiones();
            fecthComunas();
            fetchTabla();  
            fetchReporteGiras(); 
            fetchReembolsos(); 
           
        }, []);

    // Refiltra giras cuando cambia la búsqueda o el año seleccionado
    useEffect(() => {
        if (giras.length > 0) {
            const girasActualizadas = filtrarGiras(giras, anioFiltro, busqueda);
            setGirasFiltradas(girasActualizadas);
        }
    }, [anioFiltro, busqueda, giras]);
    
    const floats = [
        { "title": "total_products", "digit": 547, "icon": "shopping_bag", "variant": "lg blue" }, 
        { "title": "total_categories", "digit": 605, "icon": "widgets", "variant": "lg green" },
        { "title": "total_barnds", "digit": 249, "icon": "verified_user", "variant": "lg purple" }
    ];

    const [showCreateGiraModal, setShowCreateGiraModal] = useState(false);
    const [giraData, setGiraData] = useState({
        programa: '',
        tramo: '',
        establecimientos: '',
        curso: '',
        region: '',
        comuna: '',
        valorGira: '',
        valorServicioAdicional: '',
        valorTotalGira: '',
        numeroCuotas: '',
        valorCuota: '',
        abonoPagado: '',
        fechaInicioCuotas: '',
        fechaUltimaCuota: '',
        diaVencimientoCuota: 5,
        fechaViaje: '',
        fechaTerminoViaje: '',
        datosContacto: '',
        celularContacto: '',
        emailContacto: '',
        pagoInicial:0,
        liberados:0,
        anio: new Date().getFullYear(),
        aplicaMultas: true,
        multaMensual: false,
        pagoDolares: false,
        porcMulta: 0.0024,
        fechaAbono: '',
        abonoPendiente: false,
        gestor: '',
        gestorEmail: '',
        traslado: false,
        puntoEncuentro: '',
        horarioEncuentro: '',
        tipoTransporte: '',
        aerolinea: '',
        numVuelo: '',
        horarioVueloIda: '',
        horarioVueloRegreso: '',
        tipoBus: '',
        patenteBus: '',
        nombreChofer1: '',
        nombreChofer2: '',
        horarioSalida: '',
        horarioRegreso: '',
        coordinador: '',
        hotel: '',
        voucherSeguro: '',
    });

    // Calcular valor total gira (Precio Unitario + Servicio Adicional)
    useEffect(() => {
        if (giraData.valorGira) {
            const valorUnitario = typeof giraData.valorGira === 'string' 
                ? parseFloat(giraData.valorGira.replace(',', '.'))
                : parseFloat(giraData.valorGira);
            
            const servicioAdicional = typeof giraData.valorServicioAdicional === 'string' 
                ? parseFloat(giraData.valorServicioAdicional.replace(',', '.')) || 0
                : (parseFloat(giraData.valorServicioAdicional) || 0);
            
            const total = valorUnitario + servicioAdicional;
            
            setGiraData(prev => ({
                ...prev,
                valorTotalGira: isNaN(total) ? '' : total
            }));
        }
    }, [giraData.valorGira, giraData.valorServicioAdicional]);

    const handleShowCreateGiraModal = () => setShowCreateGiraModal(true);
    const handleCloseCreateGiraModal = () => {
        setShowCreateGiraModal(false);
        setGiraData({
            programa: '',
            tramo: '',
            establecimientos: '',
            curso: '',
            region: '',
            comuna: '',
            valorGira: '',
            valorServicioAdicional: '',
            valorTotalGira: '',
            numeroCuotas: '',
            valorCuota: '',
            abonoPagado: '',
            fechaInicioCuotas: '',
            fechaUltimaCuota: '',
            diaVencimientoCuota: '',
            fechaViaje: '',
            fechaTerminoViaje: '',
            datosContacto: '',
            celularContacto: '',
            emailContacto: '',
            pagoInicial:0,
            liberados:0,
            anio: new Date().getFullYear(),
            aplicaMultas: true,
            multaMensual: false,
            pagoDolares: false,
            porcMulta: 1,
            fechaAbono: '',
            abonoPendiente: false,
            gestor: '',
            gestorEmail: '',
            traslado: false,
            puntoEncuentro: '',
            horarioEncuentro: '',
            tipoTransporte: '',
            aerolinea: '',
            numVuelo: '',
            horarioVueloIda: '',
            horarioVueloRegreso: '',
            tipoBus: '',
            patenteBus: '',
            nombreChofer1: '',
            nombreChofer2: '',
            horarioSalida: '',
            horarioRegreso: '',
            coordinador: '',
            hotel: '',
            voucherSeguro: '',
        });
    };

    // Funciones para el modal de reporte de pagos
    const handleShowReportModal = () => setShowReportModal(true);
    const handleCloseReportModal = () => setShowReportModal(false);

    // Funciones para el modal de reporte de tallas
    const handleShowReportTallasModal = () => setShowReportTallasModal(true);
    const handleCloseReportTallasModal = () => setShowReportTallasModal(false);

    const handleReportInputChange = (event) => {
        const { name, value } = event.target;
        setReportData({
            ...reportData,
            [name]: value
        });
    };

    const handleReportTallasInputChange = (event) => {
        const { name, value } = event.target;
        setReportTallasData({
            ...reportTallasData,
            [name]: value
        });
    };

    const handleGenerateReport = async () => {
        try {
            console.log('Generando reporte de pagos:', reportData);
            
            // Llamada a la API para generar el reporte usando el método getReportePagos
            const blob = await getReportePagos(reportData.fechaInicio, reportData.fechaFin);
            
            if (blob && !blob.error) {
                // Crear un enlace para descargar el archivo
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte_pagos_${reportData.fechaInicio}_${reportData.fechaFin}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    title: 'Reporte Generado',
                    text: `El reporte de pagos ha sido descargado exitosamente`
                });
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar el reporte:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al generar el reporte de pagos: ' + error.message
            });
        }

        handleCloseReportModal();
    };

    const handleGenerateReportTallas = async () => {
        try {
            console.log('Generando reporte de tallas:', reportTallasData);
            
            // Llamada a la API para generar el reporte de tallas
            const blob = await getReporteTallas(reportTallasData.anio);
            
            if (blob && !blob.error) {
                // Crear un enlace para descargar el archivo
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte_tallas_${reportTallasData.anio}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    title: 'Reporte Generado',
                    text: `El reporte de tallas para el año ${reportTallasData.anio} ha sido descargado exitosamente`
                });
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar el reporte:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al generar el reporte de tallas: ' + error.message
            });
        }

        handleCloseReportTallasModal();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setGiraData({
            ...giraData,
            [name]: value
        });
    };

    const handleCreateGira = () => {
        // Validar campos obligatorios
        const camposRequeridos = [
            { key: 'programa', label: 'Programa' },
            { key: 'tramo', label: 'Tramo' },
            { key: 'establecimientos', label: 'Establecimiento' },
            { key: 'curso', label: 'Curso' },
            { key: 'region', label: 'Región' },
            { key: 'comuna', label: 'Comuna' },
            { key: 'valorGira', label: 'Precio Unitario Gira' },
            { key: 'numeroCuotas', label: 'Número de Cuotas' },
            { key: 'diaVencimientoCuota', label: 'Día Vencimiento Cuota' },
            { key: 'datosContacto', label: 'Nombre del Responsable Curso' },
            { key: 'celularContacto', label: 'Celular del Responsable Curso' },
            { key: 'emailContacto', label: 'Email del Responsable Curso' },
        ];

        const camposVacios = camposRequeridos.filter(campo => !giraData[campo.key] || giraData[campo.key].toString().trim() === '');

        if (camposVacios.length > 0) {
            let errorMsg = '<strong>Por favor completa los siguientes campos:</strong><br><ul style="text-align: left;">';
            camposVacios.forEach(campo => {
                errorMsg += `<li>${campo.label}</li>`;
            });
            errorMsg += '</ul>';

            Swal.fire({
                icon: 'warning',
                title: 'Campos incompletos',
                html: errorMsg
            });
            return;
        }

        creaGira(giraData)
        .then(res => {
          Swal.close();
       //  fetchTabla();
          if (res.error === false) {
            Swal.fire({
              icon: 'success',
              text: 'Gira creada correctamente.'
            })
            cargaTabla();
            //navigateTo(ROUTES.USUARIOS);
          }
          else {
            let errorMsg = res.msg;
            if (res.errores) {
              errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
              res.errores.forEach(error => {
                errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
              });
              errorMsg += '</tbody></table>';
            }

            Swal.fire({
              icon: 'error',
            
              html: errorMsg
            })
          }

        });
      
        handleCloseCreateGiraModal();
    };

    const handleRegionChange = (event) => {
        const { value } = event.target;
        setGiraData({
            ...giraData,
            region: value,
            comuna: '' // Reset comuna when region changes
        });
        // Fetch comunas based on selected region
        fetchComunas(value);
    };

     const handleComunaChange = (event) => {
        const { value } = event.target;
        setGiraData({
            ...giraData,
            comuna: value 
        });
        // Fetch comunas based on selected region
        fetchEstablecimientos(value);
    };

    const cargaTabla = async () => {
        const res = await getGiras();
        setGiras(res);
        setGirasFiltradas(res);
    }

    const handleCloneGira = (giraId, giraCurso) => {
        Swal.fire({
            title: '¿Clonar Gira?',
            text: `¿Deseas clonar la gira del curso "${giraCurso}"?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, clonar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await cloneGira(giraId);
                    if (response.error === false) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'La gira ha sido clonada correctamente.'
                        });
                        cargaTabla();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response.msg || 'Error al clonar la gira.'
                        });
                    }
                } catch (error) {
                    console.error('Error al clonar gira:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al clonar la gira.'
                    });
                }
            }
        });
    }

    const fetchComunas = (regionId) => {
        // Replace with your actual API call
        const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);
    };

    const fetchEstablecimientos = async (comunaId) => {
        // Replace with your actual API call
       /* const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);*/
         const res = await getEstablecimientos(comunaId);
        console.log(res);
        setSelectEstablecimiento(res.data);
    };


    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Giras de Estudios</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {reporteGiras.map((float, index) => (
                    <Col key={ index } sm={6} lg={4}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))}
                 <Col xl={12}>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <Button variant="primary" onClick={handleShowCreateGiraModal}>
                            Crear Gira de Estudios
                        </Button>

                        {(usuario?.roles?.[0]?.codigo === "ADMIN" || usuario?.roles?.[0]?.codigo === "MASTER") && (
                            <>
                                <Button variant="success" onClick={handleShowReportModal}>
                                    Reporte de Pagos
                                </Button>
                                <Button variant="info" onClick={handleShowReportTallasModal}>
                                    Reporte de Tallas
                                </Button>
                            </>
                        )}
                    </div>
                </Col>
                <Col sm={6} lg={6}>
                    <Form.Group controlId="formBusqueda">
                        <Form.Label>Buscar Gira</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Buscar por establecimiento, curso, región..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col sm={6} lg={6}>
                    <Form.Group controlId="formAnioFiltro">
                        <Form.Label>Filtrar por Año</Form.Label>
                        <Form.Select
                            value={anioFiltro}
                            onChange={(e) => setAnioFiltro(Number(e.target.value))}
                        >
                            {anios.map((year) => (
                                <option key={year} value={year} selected={year === anioActual}>
                                    {year}
                                </option>
                            ))}
                        
                        </Form.Select>
                    </Form.Group>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs activeKey={tabActive} onSelect={(k) => setTabActive(k)} className="mb-3">
                            <Tab eventKey="giras" title="Giras de Estudios">
                                <Row>
                                    <Col xl={12}>
                                        <div className="mc-table-responsive">
                                            <table className="mc-table product">
                                                <thead className="mc-table-head primary">
                                                    <tr>
                                                       
                                                        {products.thead?.map((item, index) => (
                                                            <th key={ index }>{ t(item) }</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody className="mc-table-body even">
                                                    {girasFiltradas?.map((item, index) => (
                                                        <tr key={ index }> 
                                                            <td>
                                                            { item.gir_id }  
                                                            </ td>
                                                            <td>
                                                                <div className="mc-table-product md">
                                                                   
                                                                    <div className="mc-table-group">
                                                                        <h6>{ item.est_nombre }</h6>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{ item.gir_curso }</td>
                                                            <td>{ item.programa }</td>
                                                            <td>{ item.tramo }</td>
                                                            <td>{ item.total_pasajeros }</td>
                                                            <td>{ item.reg_nombre }</td>
                                                            <td>
                                                               { item.com_nombre }
                                                                    
                                                               
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <div><strong>Apoderados:</strong> { item.total_apoderados }</div>
                                                                    <div><strong>SI:</strong> { item.total_apoderados_ingresados }</div>
                                                                    <div><strong>NO:</strong> { item.total_apoderados_no_ingresados }</div>
                                                                </div>
                                                            </td>
                                                           
                                                            
                                                            <td>
                                                                <div className="mc-table-action">
                                                                    <AnchorComponent to={{
                                                                          pathname: "/ver-gira",
                                                                          search: "?gira="+item.gir_id,
                                                                    }} title="View" className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                                                    <button 
                                                                        title="Solicitudes de Cupo" 
                                                                        className="material-icons"
                                                                        onClick={() => {
                                                                            setGiraSeleccionada(item);
                                                                            setTabActive('solicitudesCupo');
                                                                        }}
                                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#2196F3', marginLeft: '10px', fontSize: '1.3rem' }}
                                                                    >
                                                                        <i className='material-icons'>assignment</i>
                                                                    </button>
                                                                    <button 
                                                                        title="Clone" 
                                                                        className="material-icons clone"
                                                                        onClick={() => handleCloneGira(item.gir_id, item.gir_curso)}
                                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#666', marginLeft: '10px' }}
                                                                    >
                                                                        <i className='material-icons'>content_copy</i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="reembolsos" title="Reembolsos">
                                <Row>
                                    <Col xl={12}>
                                        <div className="mc-table-responsive">
                                            <table className="mc-table product">
                                                <thead className="mc-table-head primary">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Alumno</th>
                                                        <th>RUT</th>
                                                        <th>Gira</th>
                                                        <th>Tipo</th>
                                                        <th>Motivo</th>
                                                        <th>Monto Solicitado</th>
                                                        <th>Monto Aprobado</th>
                                                        <th>Estado</th>
                                                        <th>Fecha Solicitud</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="mc-table-body even">
                                                    {reembolsos?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.reem_id}</td>
                                                            <td>{item.alu_nombres} {item.alu_apellidos}</td>
                                                            <td>{item.alu_rut}</td>
                                                            <td>{item.est_nombre} - {item.gir_curso}</td>
                                                            <td>{item.reem_tipo}</td>
                                                            <td>{item.reem_motivo}</td>
                                                            <td>${item.reem_monto_solicitado?.toLocaleString('es-CL')}</td>
                                                            <td>${item.reem_monto_aprobado ? item.reem_monto_aprobado.toLocaleString('es-CL') : '-'}</td>
                                                            <td>
                                                                {item.reem_estado === 'Pendiente' && <p className="mc-table-badge purple">{item.reem_estado}</p>}
                                                                {item.reem_estado === 'Aprobado' && <p className="mc-table-badge green">{item.reem_estado}</p>}
                                                                {item.reem_estado === 'Rechazado' && <p className="mc-table-badge red">{item.reem_estado}</p>}
                                                                {item.reem_estado === 'Reembolsado' && <p className="mc-table-badge blue">{item.reem_estado}</p>}
                                                            </td>
                                                            <td>{item.reem_fecha_solicitud}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {reembolsos?.length === 0 && (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <p>No hay reembolsos registrados.</p>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="solicitudesCupo" title="Solicitudes de Cupo">
                                <Row>
                                    <Col xl={12}>
                                        <div style={{ marginTop: '20px' }}>
                                            {giraSeleccionada ? (
                                                <div>
                                                    <div style={{ 
                                                        backgroundColor: '#E3F2FD', 
                                                        padding: '15px', 
                                                        borderRadius: '4px', 
                                                        marginBottom: '20px',
                                                        borderLeft: '4px solid #2196F3'
                                                    }}>
                                                        <h6 style={{ margin: '0 0 5px 0', color: '#2196F3', fontWeight: 'bold' }}>
                                                            Gira Seleccionada
                                                        </h6>
                                                        <p style={{ margin: '0', color: '#1565C0' }}>
                                                            {giraSeleccionada.est_nombre} - {giraSeleccionada.gir_curso} ({giraSeleccionada.gir_anio})
                                                        </p>
                                                    </div>
                                                    <SolicitudesCupoAdminComponent giraId={giraSeleccionada.gir_id} />
                                                </div>
                                            ) : (
                                                <div style={{ 
                                                    textAlign: 'center', 
                                                    padding: '60px 20px',
                                                    color: '#999'
                                                }}>
                                                    <i className='material-icons' style={{ fontSize: '3rem', marginBottom: '10px', display: 'block' }}>select_check_box</i>
                                                    <p>Selecciona una gira de la tabla para ver las solicitudes de cupo</p>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                </Col>
            </Row>

            <Modal  centered backdrop="static" show={showCreateGiraModal} onHide={handleCloseCreateGiraModal}>
            <div className="mc-alert-modal" style={{ minHeight: "500px" }}>
                <Modal.Header closeButton>
                    <Modal.Title>Crear Gira de Estudios</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form >
                    <Form.Group controlId="formAnio">
                            <Form.Label>Año</Form.Label>
                            <Form.Control type="text" name="anio" value={giraData.anio} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formPrograma">
                            <Form.Label>Programa</Form.Label>
                            <Form.Select name="programa" onChange={handleInputChange} >
                                <option>Seleccionar Programa</option>
                                {selectPrograma?.map((programa) => (
                                    <option key={programa.id} value={programa.id}>{programa.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formTramo">
                            <Form.Label>Tramo</Form.Label>
                            <Form.Select name="tramo" onChange={handleInputChange} >
                                <option>Seleccionar Tramo</option>
                                {selectTramo?.map((tramo) => (
                                    <option key={tramo.id} value={tramo.id}>{tramo.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formPagoDolares">
                        <Form.Label>Gira en Dolares</Form.Label>
                            <Form.Check
                                type="checkbox"

                                name="pagoDolares"
                                checked={giraData.pagoDolares}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        pagoDolares: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>
                        <Form.Group controlId="formAplicaMultas">
                        <Form.Label>Aplicar Multas</Form.Label>
                            <Form.Check
                                type="checkbox"
                                
                                name="aplicaMultas"
                                checked={giraData.aplicaMultas}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        aplicaMultas: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>
                         
                         <Form.Group controlId="formValorGira">
                            <Form.Label>Porcentaje Multa</Form.Label>
                            <Form.Control type="text" name="porcMulta" value={giraData.porcMulta} onChange={handleInputChange} />
                        </Form.Group>
                         <Form.Group controlId="formRegion">
                            <Form.Label>Región</Form.Label>
                            <Form.Select  name="region" value={giraData.region} onChange={handleRegionChange} >
                                <option>Seleccionar Región</option>
                                {selectRegion?.map((region) => (
                                    <option key={region.id} value={region.id}>{region.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formComuna">
                            <Form.Label>Comuna</Form.Label>
                            <Form.Select type="text" name="comuna" value={giraData.comuna} onChange={handleComunaChange} >
                                <option>Seleccionar Comuna</option>
                                {comunas?.map((comuna) => (
                                    <option key={comuna.com_id} value={comuna.com_id}>{comuna.com_nombre}</option>
                                ))}
                            </Form.Select>    
                        </Form.Group>
                        <Form.Group controlId="formEstablecimientos">
                            <Form.Label>Establecimientos</Form.Label>
                            <Form.Control type="text" name="establecimientos" value={giraData.establecimientos} onChange={handleInputChange} placeholder="Nombre del establecimiento" />
                        </Form.Group>
                        <Form.Group controlId="formCurso">
                            <Form.Label>Curso</Form.Label>
                            <Form.Control type="text" name="curso" value={giraData.curso} onChange={handleInputChange} />
                        </Form.Group>
                       
                        <Form.Group controlId="formValorGira">
                            <Form.Label>Precio Unitario Gira</Form.Label>
                            <Form.Control type="number" name="valorGira" value={giraData.valorGira} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formValorServicioAdicional">
                            <Form.Label>Valor Servicio Adicional</Form.Label>
                            <Form.Control type="number" step="0.01" name="valorServicioAdicional" value={giraData.valorServicioAdicional || ""} onChange={handleInputChange} placeholder="Ingrese el valor del servicio adicional" />
                        </Form.Group>
                        <Form.Group controlId="formValorTotalGira">
                            <Form.Label>Valor Total Gira</Form.Label>
                            <Form.Control type="number" name="valorTotalGira" value={giraData.valorTotalGira || ""} onChange={handleInputChange} placeholder="Se calcula automáticamente" disabled />
                        </Form.Group>
                        
                        <Form.Group controlId="formNumeroCuotas">
                            <Form.Label>Número de Cuotas</Form.Label>
                            <Form.Control type="number" name="numeroCuotas" value={giraData.numeroCuotas} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formValorCuota">
                            <Form.Label>Valor Cuota</Form.Label>
                            <Form.Control type="number" step="0.01" name="valorCuota" value={giraData.valorCuota} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAbonoPagado">
                            <Form.Label>Abono Pagado</Form.Label>
                            <Form.Control type="number" step="0.01" name="abonoPagado" value={giraData.abonoPagado} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaInicioCuotas">
                            <Form.Label>Fecha Inicio Cuotas</Form.Label>
                            <Form.Control type="date" name="fechaInicioCuotas" value={giraData.fechaInicioCuotas} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaUltimaCuota">
                            <Form.Label>Fecha Última Cuota</Form.Label>
                            <Form.Control type="date" name="fechaUltimaCuota" value={giraData.fechaUltimaCuota} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDiaVencimientoCuota">
                            <Form.Label>Día Vencimiento Cuota</Form.Label>
                            <Form.Control type="number" name="diaVencimientoCuota" value={giraData.diaVencimientoCuota} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formLiberados">
                            <Form.Label>Liberados</Form.Label>
                            <Form.Control type="text" name="liberados" value={giraData.liberados} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaViaje">
                            <Form.Label>Fecha Inicio del Viaje</Form.Label>
                            <Form.Control type="date" name="fechaViaje" value={giraData.fechaViaje} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaTerminoViaje">
                            <Form.Label>Fecha Termino Viaje</Form.Label>
                            <Form.Control type="date" name="fechaTerminoViaje" value={giraData.fechaTerminoViaje} onChange={handleInputChange} />
                        </Form.Group>

                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Nombre del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="datosContacto" value={giraData.datosContacto} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Celular del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="celularContacto" value={giraData.celularContacto} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Email del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="emailContacto" value={giraData.emailContacto} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaAbono">
                            <Form.Label>Fecha Abono</Form.Label>
                            <Form.Control type="date" name="fechaAbono" value={giraData.fechaAbono} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formAbonoPendiente">
                            <Form.Label>Abono Pendiente</Form.Label>
                            <Form.Check
                                type="checkbox"
                                name="abonoPendiente"
                                checked={giraData.abonoPendiente}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        abonoPendiente: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>

                        <hr className="my-4" />
                        <h5>Información Adicional (Opcional)</h5>
                        <hr className="my-3" />

                        <Form.Group controlId="formGestor">
                            <Form.Label>Gestor(a)</Form.Label>
                            <Form.Control type="text" name="gestor" value={giraData.gestor} onChange={handleInputChange} placeholder="Nombre del gestor" />
                        </Form.Group>
                        <Form.Group controlId="formGestorEmail">
                            <Form.Label>Email Gestor(a)</Form.Label>
                            <Form.Control type="email" name="gestorEmail" value={giraData.gestorEmail} onChange={handleInputChange} placeholder="Email del gestor" />
                        </Form.Group>

                        <Form.Group controlId="formTraslado">
                            <Form.Label>Incluye Traslado Colegio-Apto-Colegio</Form.Label>
                            <Form.Check
                                type="checkbox"
                                name="traslado"
                                checked={giraData.traslado}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        traslado: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>
                        {giraData.traslado && (
                            <>
                                <Form.Group controlId="formPuntoEncuentro">
                                    <Form.Label>Punto de Encuentro</Form.Label>
                                    <Form.Control type="text" name="puntoEncuentro" value={giraData.puntoEncuentro} onChange={handleInputChange} placeholder="Ej: Dirección Colegio, Aeropuerto Nacional, etc" />
                                </Form.Group>
                                <Form.Group controlId="formHorarioEncuentro">
                                    <Form.Label>Horario de Encuentro</Form.Label>
                                    <Form.Control type="time" name="horarioEncuentro" value={giraData.horarioEncuentro} onChange={handleInputChange} />
                                </Form.Group>
                            </>
                        )}

                        <Form.Group controlId="formTipoTransporte">
                            <Form.Label>Tipo de Transporte</Form.Label>
                            <Form.Select name="tipoTransporte" value={giraData.tipoTransporte} onChange={handleInputChange}>
                                <option value="">Seleccionar Tipo</option>
                                <option value="Aéreo">Aéreo</option>
                                <option value="Terrestre">Terrestre</option>
                            </Form.Select>
                        </Form.Group>

                        {giraData.tipoTransporte === 'Aéreo' && (
                            <>
                                <Form.Group controlId="formAerolinea">
                                    <Form.Label>Aerolínea</Form.Label>
                                    <Form.Control type="text" name="aerolinea" value={giraData.aerolinea} onChange={handleInputChange} placeholder="Nombre de la aerolínea" />
                                </Form.Group>
                                <Form.Group controlId="formNumVuelo">
                                    <Form.Label>Número de Vuelo</Form.Label>
                                    <Form.Control type="text" name="numVuelo" value={giraData.numVuelo} onChange={handleInputChange} placeholder="Ej: LAN123" />
                                </Form.Group>
                                <Form.Group controlId="formHorarioVueloIda">
                                    <Form.Label>Horario Vuelo Ida</Form.Label>
                                    <Form.Control type="time" name="horarioVueloIda" value={giraData.horarioVueloIda} onChange={handleInputChange} />
                                </Form.Group>
                                <Form.Group controlId="formHorarioVueloRegreso">
                                    <Form.Label>Horario Vuelo Regreso</Form.Label>
                                    <Form.Control type="time" name="horarioVueloRegreso" value={giraData.horarioVueloRegreso} onChange={handleInputChange} />
                                </Form.Group>
                            </>
                        )}

                        {giraData.tipoTransporte === 'Terrestre' && (
                            <>
                                <Form.Group controlId="formTipoBus">
                                    <Form.Label>Tipo de Bus</Form.Label>
                                    <Form.Control type="text" name="tipoBus" value={giraData.tipoBus} onChange={handleInputChange} placeholder="Ej: Cama, Semi-cama, Turismo" />
                                </Form.Group>
                                <Form.Group controlId="formPatenteBus">
                                    <Form.Label>Patente Bus</Form.Label>
                                    <Form.Control type="text" name="patenteBus" value={giraData.patenteBus} onChange={handleInputChange} placeholder="Ej: XXXX-XX" />
                                </Form.Group>
                                <Form.Group controlId="formNombreChofer1">
                                    <Form.Label>Nombre Chofer 1</Form.Label>
                                    <Form.Control type="text" name="nombreChofer1" value={giraData.nombreChofer1} onChange={handleInputChange} />
                                </Form.Group>
                                <Form.Group controlId="formNombreChofer2">
                                    <Form.Label>Nombre Chofer 2</Form.Label>
                                    <Form.Control type="text" name="nombreChofer2" value={giraData.nombreChofer2} onChange={handleInputChange} />
                                </Form.Group>
                                <Form.Group controlId="formHorarioSalida">
                                    <Form.Label>Horario de Salida</Form.Label>
                                    <Form.Control type="time" name="horarioSalida" value={giraData.horarioSalida} onChange={handleInputChange} />
                                </Form.Group>
                                <Form.Group controlId="formHorarioRegreso">
                                    <Form.Label>Horario de Regreso</Form.Label>
                                    <Form.Control type="time" name="horarioRegreso" value={giraData.horarioRegreso} onChange={handleInputChange} />
                                </Form.Group>
                            </>
                        )}

                        <Form.Group controlId="formCoordinador">
                            <Form.Label>Coordinador(a)</Form.Label>
                            <Form.Control type="text" name="coordinador" value={giraData.coordinador} onChange={handleInputChange} placeholder="Nombre del coordinador" />
                        </Form.Group>

                        <Form.Group controlId="formHotel">
                            <Form.Label>Nombre Hotel</Form.Label>
                            <Form.Control type="text" name="hotel" value={giraData.hotel} onChange={handleInputChange} placeholder="Nombre del hotel" />
                        </Form.Group>

                        <Form.Group controlId="formVoucherSeguro">
                            <Form.Label>Nº Voucher Seguro Médico</Form.Label>
                            <Form.Control type="text" name="voucherSeguro" value={giraData.voucherSeguro} onChange={handleInputChange} placeholder="Número de voucher" />
                        </Form.Group>
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCreateGiraModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleCreateGira}>
                        Crear
                    </Button>
                </Modal.Footer>
                </div>
            </Modal>

            {/* Modal para Reporte de Pagos */}
            <Modal show={showReportModal} onHide={handleCloseReportModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Generar Reporte de Pagos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formFechaInicio">
                                <Form.Label>Fecha de Inicio</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="fechaInicio" 
                                    value={reportData.fechaInicio} 
                                    onChange={handleReportInputChange} 
                                />
                            </Form.Group>
                            <Form.Group controlId="formFechaFin" className="mt-3">
                                <Form.Label>Fecha de Fin</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="fechaFin" 
                                    value={reportData.fechaFin} 
                                    onChange={handleReportInputChange} 
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseReportModal}>
                            Cerrar
                        </Button>
                        <Button variant="success" onClick={handleGenerateReport}>
                            Generar Reporte
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>

            {/* Modal para Reporte de Tallas */}
            <Modal show={showReportTallasModal} onHide={handleCloseReportTallasModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Generar Reporte de Tallas de Poleras</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formAnioReporte">
                                <Form.Label>Año</Form.Label>
                                <Form.Select
                                    name="anio"
                                    value={reportTallasData.anio}
                                    onChange={handleReportTallasInputChange}
                                >
                                    {anios.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseReportTallasModal}>
                            Cerrar
                        </Button>
                        <Button variant="info" onClick={handleGenerateReportTallas}>
                            Generar Reporte
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </PageLayout>
    );
}
